module.exports = __webpack_public_path__ + "img/intro_1.0bb5ed13.jpeg";